import { AbstractControl } from '@angular/forms';
import {
  parseInput,
  validateLatitudeRange,
  validateLongitudeRange,
  validateMinutesRange,
} from './coordinate.model';
import { CoordinateKind } from './coordinate.model.v2';

export function getParsedCoordinates(control: AbstractControl, direction: CoordinateKind) {
  const input = control.value;
  if (input != null) {
    return parseInput(input, direction);
  }

  return null;
}

export function latitudeRangeValidator(control: AbstractControl) {
  const coord = getParsedCoordinates(control, CoordinateKind.Latitude);
  if (coord != null) {
    const error = validateLatitudeRange(coord.value);
    if (error != null) {
      return {
        outOfRangeError: error,
      };
    }
  }

  return null;
}

export function longitudeRangeValidator(control: AbstractControl) {
  const coord = getParsedCoordinates(control, CoordinateKind.Longitude);
  if (coord != null) {
    const error = validateLongitudeRange(coord.value);
    if (error != null) {
      return {
        outOfRangeError: error,
      };
    }
  }

  return null;
}

export function latitudeMinutesRangeValidator(control: AbstractControl) {
  const coord = getParsedCoordinates(control, CoordinateKind.Latitude);
  if (coord != null) {
    const error = validateMinutesRange(coord.minutes + coord.seconds / 60);
    if (error != null) {
      return {
        outOfRangeError: error,
      };
    }
  }

  return null;
}

export function longitudeMinutesRangeValidator(control: AbstractControl) {
  const coord = getParsedCoordinates(control, CoordinateKind.Longitude);
  if (coord != null) {
    const error = validateMinutesRange(coord.minutes + coord.seconds / 60);
    if (error != null) {
      return {
        outOfRangeError: error,
      };
    }
  }

  return null;
}
